import dayjs from "dayjs";
import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";
import { ChannelType } from "./TuvisMessagingChannels";

export const CHAT_NOT_OPTED_IN_ERROR = "CHAT_NOT_OPTED_IN";
export const WHATS_APP_SESSION_HOURS_FROM_LAST_MESSAGE = 23;
export const MAX_HOURS_BETWEEN_SEND_TEMPLATE = 23;

export const SubscribedPlatform = Type.Object({
  id: Type.String(),
  conversationId: Type.String(),
  teamId: Type.Optional(Type.String()),
});

export type SubscribedPlatform = TypeBoxToType<typeof SubscribedPlatform>;

export const ImChat = Type.Object({
  _id: Type.String(),
  orgId: Type.String(),
  firstName: Type.Optional(Type.String()),
  lastName: Type.Optional(Type.String()),
  phone: Type.Number(),
  createdAt: Type.String(),
  updatedAt: Type.String(),
  lastWaMessageAt: Type.Optional(Type.String()),
  lastWaTemplateAt: Type.Optional(Type.String()),
  createdBy: Type.Union([Type.Literal("user"), Type.Literal("webhook")]),
  type: ChannelType,
  contactId: Type.Optional(Type.String()),
  isArchived: Type.Boolean(),
  phoneId: Type.String(),
  labels: Type.Optional(Type.Array(Type.String())),
  subscribedPlatforms: Type.Optional(Type.Array(SubscribedPlatform)),
  currentConversationId: Type.Optional(Type.String()),
});
export type ImChat = TypeBoxToType<typeof ImChat>;

export function isOptIn(chat: ImChat) {
  return (
    chat.type === "imessage" ||
    chat.type === "twilio" ||
    (Boolean(chat.lastWaMessageAt) && dayjs().diff(dayjs(chat.lastWaMessageAt), "hours") < WHATS_APP_SESSION_HOURS_FROM_LAST_MESSAGE)
  );
}

export function isTemplateSent(chat: ImChat) {
  return (
    chat.type === "imessage" ||
    chat.type === "twilio" ||
    (Boolean(chat.lastWaTemplateAt) && dayjs().diff(dayjs(chat.lastWaTemplateAt), "hours") < MAX_HOURS_BETWEEN_SEND_TEMPLATE)
  );
}
